import { useEffect, useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useCourseSearchDropdown } from '../../../hooks/useCourseSearchDropdown';
import type { LookupAutocompleteProps } from './CompanyAutocomplete';

/** Autocomplete de curso (lookup `shared/courses`). */
export function CourseAutocomplete({
  value,
  selectedLabel: selectedLabelProp = '',
  onChange,
  label,
  placeholder,
  hasError,
}: LookupAutocompleteProps) {
  const [search, setSearch] = useState('');
  const [inputText, setInputText] = useState(selectedLabelProp);
  const { options, isQuerySuccess } = useCourseSearchDropdown(search);

  useEffect(() => {
    setInputText(selectedLabelProp);
  }, [selectedLabelProp]);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value !== null ? String(value) : ''}
      selectedLabel={inputText}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      hasError={hasError ?? false}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id ? Number(id) : null, itemLabel);
        setInputText(itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange(null, '');
        setInputText('');
        setSearch('');
      }}
    />
  );
}
